import { useMemo } from 'react';
import find from 'lodash/find';
import { ISelectValue } from 'components/ui';

/**
 * @deprecated удалить, когда будет везде использоваться Select из components/ui
 */
export const useSelectedOption = (
  options: ISelectValue[],
  selectedValue: string
): ISelectValue | null => {
  return useMemo(
    () => find(options, { value: selectedValue }) || null,
    [options, selectedValue]
  );
};
